import React from 'react';
import { motion } from 'framer-motion';
import EditableField from './EditableField';
import './Contact.css';

const contactLinks = [
  {
    label: 'Email',
    value: 'ph@chummychum.org',
    href: 'mailto:ph@chummychum.org',
    icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    value: 'linkedin.com/in/rameshgenomal',
    href: 'https://linkedin.com/in/rameshgenomal',
    icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
        <rect x="2" y="9" width="4" height="12"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    label: 'GitHub',
    value: 'github.com/Rgeno999',
    href: 'https://github.com/Rgeno999',
    icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
      </svg>
    ),
  },
  {
    label: 'Website',
    value: 'chummychum.org',
    href: 'https://www.chummychum.org',
    icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
];

function Contact() {
  return (
    <section className="contact section-padding" id="contact">
      <div className="container">
        <motion.div
          className="contact__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Get In Touch</span>
          <h2 className="section-title">
            Let's build something<br />
            <span className="text-gradient">amazing together</span>
          </h2>
          <EditableField
            storageKey="contact-subtitle"
            defaultValue="I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision."
            tag="p"
            className="contact__subtitle"
            multiline
          />
        </motion.div>

        <div className="contact__grid">
          {contactLinks.map((link, i) => (
            <motion.a
              key={link.label}
              href={link.href}
              className="contact__card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
              whileHover={{ y: -6, transition: { duration: 0.3 } }}
            >
              <div className="contact__card-icon">{link.icon}</div>
              <div>
                <span className="contact__card-label">{link.label}</span>
                <span className="contact__card-value">{link.value}</span>
              </div>
              <svg className="contact__card-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"/>
                <polyline points="7 7 17 7 17 17"/>
              </svg>
            </motion.a>
          ))}
        </div>

        <motion.div
          className="contact__cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="contact__cta-orb" />
          <EditableField storageKey="contact-cta-title" defaultValue="Ready to start a project?" tag="h3" className="contact__cta-title" />
          <EditableField storageKey="contact-cta-text" defaultValue="Drop me a line and let's make it happen." tag="p" className="contact__cta-text" />
          <a href="mailto:ph@chummychum.org" className="contact__cta-btn">
            Say Hello
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default Contact;
